// src/components/gamification/ChallengeCard.tsx
import React from 'react';
import { Card, CardContent, Typography, LinearProgress, Box, Chip } from '@mui/material';
import { Challenge } from '../../services/interfaces';

interface ChallengeCardProps {
    challenge: Challenge;
}

export const ChallengeCard: React.FC<ChallengeCardProps> = ({ challenge }) => {
    const progress = (challenge.progress / challenge.target) * 100;
    const daysLeft = Math.ceil((new Date(challenge.endDate).getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24));

    return (
        <Card sx={{ mb: 2 }}>
            <CardContent>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                    <Typography variant="h6">{challenge.name}</Typography>
                    <Chip 
                        label={`${challenge.pointsReward} поена`}
                        color="primary"
                        size="small"
                    />
                </Box>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                    {challenge.description}
                </Typography>
                <Box sx={{ mt: 2 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                        <Typography variant="body2">
                            Напредак: {challenge.progress}/{challenge.target}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            {daysLeft} дана до краја
                        </Typography>
                    </Box>
                    <LinearProgress 
                        variant="determinate" 
                        value={progress} 
                        sx={{ height: 8, borderRadius: 4 }}
                    />
                </Box>
            </CardContent>
        </Card>
    );
};
